/* Lazy-loads wv8-builder.module.js and adds "Personalizar" entry points on homepage cards and dialogs. */
(function () {
  'use strict';

  var SAUNA_FAMILIES = { premium: 1, finlandesa: 1, exterior: 1, profesional: 1, infrarrojos: 1 };
  var BATH_PREFIX = /^wv-|^wv-g22/i;

  var root = document.getElementById('wv-home');
  if (!root || !document.getElementById('wv-builder')) return;

  var modulePromise = null;

  function assets() {
    var el = document.getElementById('wv-builder-assets');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function loadModule() {
    // Shopify's asset minifier rewrites dynamic import() to require(), so load via a module tag.
    if (!modulePromise) {
      var cfg = assets();
      var url = cfg.moduleUrl || '/assets/wv8-builder.module.js';
      modulePromise = new Promise(function (resolve, reject) {
        if (window.WVBuilder) return resolve(window.WVBuilder);
        var s = document.createElement('script');
        s.type = 'module';
        s.src = url;
        s.onload = function () {
          if (window.WVBuilder) resolve(window.WVBuilder);
          else reject(new Error('WVBuilder missing after load'));
        };
        s.onerror = function () {
          modulePromise = null;
          reject(new Error('Failed to load ' + url));
        };
        document.head.appendChild(s);
      });
    }
    return modulePromise;
  }

  function builderKind(id, category) {
    if (SAUNA_FAMILIES[id]) return 'sauna';
    if (BATH_PREFIX.test(id) || id === 'wv-g22-professional') return 'bath';
    if (category === 'saunas') return 'sauna';
    if (category === 'banos') return 'bath';
    return null;
  }

  function openBuilder(id, category) {
    var kind = builderKind(id, category);
    if (!kind) return;
    var initial = { kind: kind, id: id };
    if (kind === 'sauna' && id === 'exterior') initial.location = 'Exterior';
    loadModule().then(function (mod) {
      if (mod.open) mod.open(initial);
    }).catch(function (err) {
      console.error('[WV builder]', err);
    });
  }

  window.WVBuilderOpen = openBuilder;

  function catalogMeta(id) {
    var list = window.WV_CATALOG || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  function decorateCard(card) {
    var id = card.dataset.productCard;
    if (!id || card.querySelector('.wv-builder-cta')) return;
    var meta = catalogMeta(id);
    if (!meta || !builderKind(id, meta.category)) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wv-builder-cta';
    btn.dataset.wvBuilderOpen = id;
    btn.setAttribute('data-wv-i18n-en', 'Customise');
    btn.dataset.wvI18nEs = 'Personalizar';
    btn.dataset.wvI18nLang = window.WV_LANG === 'en' ? 'en' : 'es';
    btn.textContent = window.WV_LANG === 'en' ? 'Customise' : 'Personalizar';
    var actions = card.querySelector('.product-actions');
    if (actions) actions.appendChild(btn);
    else card.appendChild(btn);
  }

  var lastOpened = null;
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-open-product]');
    if (opener) lastOpened = opener.dataset.openProduct;
  }, true);

  function decorateDialog() {
    var info = root.querySelector('#product-detail-content .detail-info');
    if (!info || !lastOpened || info.querySelector('.wv-builder-detail')) return;
    var meta = catalogMeta(lastOpened);
    if (!meta || !builderKind(lastOpened, meta.category)) return;
    var box = document.createElement('div');
    box.className = 'wv-builder-detail';
    var en = window.WV_LANG === 'en';
    box.innerHTML =
      '<span class="eyebrow">' + (en ? 'CONFIGURATOR' : 'CONFIGURADOR') + '</span>' +
      '<p class="form-note">' + (en ? 'Explore woods, finishes and options before adding the model to your project.' : 'Explora maderas, acabados y opciones antes de añadir el modelo a tu proyecto.') + '</p>' +
      '<button type="button" class="button dark wv-builder-cta" data-wv-builder-open="' + lastOpened + '">' + (en ? 'Customise' : 'Personalizar') + '</button>';
    var anchor = info.querySelector('.detail-go-project');
    if (anchor) info.insertBefore(box, anchor);
    else info.appendChild(box);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wv-builder-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.dataset.wvBuilderOpen;
    var meta = catalogMeta(id);
    var dialog = root.querySelector('#product-dialog');
    if (dialog && dialog.open) dialog.close();
    openBuilder(id, meta && meta.category);
  }, true);

  var grid = root.querySelector('#product-grid');
  if (grid) {
    new MutationObserver(function () {
      grid.querySelectorAll('[data-product-card]').forEach(decorateCard);
    }).observe(grid, { childList: true, subtree: true });
    grid.querySelectorAll('[data-product-card]').forEach(decorateCard);
  }

  var detail = root.querySelector('#product-detail-content');
  if (detail) {
    new MutationObserver(decorateDialog).observe(detail, { childList: true });
  }

  /* Tienda and other pages link here with /#builder?… — load the module on arrival (it opens from the hash). */
  function bootFromHashLink() {
    if (!/^#builder(\?|$)/.test(location.hash)) return;
    loadModule().then(function (mod) {
      var parse = mod.parseHash || (window.WVBuilder && window.WVBuilder.parseHash);
      var state = parse && parse();
      if (state && mod.open) mod.open(state);
    }).catch(function (err) {
      console.error('[WV builder]', err);
    });
  }

  function applyPendingProject() {
    if (document.getElementById('wv-tienda-data')) return;
    loadModule().then(function (mod) {
      if (mod.applyPendingFromStorage) mod.applyPendingFromStorage();
    }).catch(function () {});
  }

  function scheduleHashBoot() {
    bootFromHashLink();
    setTimeout(bootFromHashLink, 120);
    applyPendingProject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHashBoot);
  } else {
    scheduleHashBoot();
  }
  window.addEventListener('hashchange', bootFromHashLink);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) scheduleHashBoot();
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a.wv-builder-cta[href^="#builder"]');
    if (!link) return;
    e.preventDefault();
    var href = link.getAttribute('href') || '';
    if (location.hash === href) bootFromHashLink();
    else location.hash = href.startsWith('#') ? href.slice(1) : href;
  });
})();
